import { useState } from "react";
import { List as MuiList } from "@material-ui/core";

import { LinksType } from "../Menu";
import { ListItem } from "./ListItem";

type ListProps = {
  links: LinksType;
  activePath: string;
};

export const List = ({ links, activePath }: ListProps) => {
  const [isOpen, setIsOpen] = useState<string>();

  return (
    <MuiList style={{ padding: 0 }}>
      {links.map((link) => (
        <ListItem
          {...link}
          activePath={activePath}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          key={`list-${link.path}`}
        />
      ))}
    </MuiList>
  );
};
